<template>
  <div id="homePageCon">
    <homePageTop />
    <!-- 网站简介视频弹窗 -->
    <beginnerTipsDia ref="BeginnerTipsDia" />
    <!-- 轮播图 -->
    <SlideShow />
    <!-- 中国进口：一站式采购与物流解决方案 -->
    <section class="homepage-seo-section sr-only">
      <h1 class="homepage-seo-h1">
        {{ $fanyi("中国进口：一站式采购与物流解决方案") }}
      </h1>
    </section>
    <!-- 网站优势 -->
    <websiteAdvantages v-if="show" />
    <!-- 著名供应商 -->
    <famousSupplier :show="show" />
    <!-- 如何运作 -->
    <howToOperate v-if="show" />
    <!-- 著名产品 -->
    <famousProducts :show="show" />
    <!-- 进口好处 -->
    <importBenefits v-if="show" />
    <!-- 注册邀请 -->
    <registrationInvitation v-if="show" />
    <!-- 常见问题 -->
    <commonProblem v-if="show" />
    <Foot />
  </div>
</template>

<script>
import beginnerTipsDia from "../../components/homePage/beginnerTipsDia.vue";
import homePageTop from "../../components/head/HomePageTop.vue";
import famousSupplier from "../../components/homePage/famousSupplier.vue";
import famousProducts from "../../components/homePage/famousProducts.vue";
import registrationInvitation from "../../components/homePage/registrationInvitation.vue";
import websiteAdvantages from "../../components/homePage/websiteAdvantages.vue";
import howToOperate from "../../components/homePage/howToOperate.vue";
import importBenefits from "../../components/homePage/importBenefits.vue";
import SlideShow from "../../components/homePage/SlideShow.vue";
import commonProblem from "../../components/homePage/commonProblem.vue";
import Foot from "../../components/foot/Foot.vue";
export default {
  data() {
    return {
      show: !localStorage.getItem("user_token"),
    };
  },
  components: {
    homePageTop,
    Foot,
    beginnerTipsDia,
    famousSupplier,
    famousProducts,
    registrationInvitation,
    websiteAdvantages,
    howToOperate,
    importBenefits,
    commonProblem,
    SlideShow,
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  watch: {
    "$store.state.userInfo"(onew, old) {
      console.log(!!onew);
      if (!onew) {
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
#homePageCon {
  background-color: white;
  min-width: 1470px;
}

// 首页 SEO 标题区：与 Banner、优势卡片保持适中间距
.homepage-seo-section {
  padding: 0 0 20px;
  background: #fafafa;

  &__inner {
    width: 1400px;
    margin: 0 auto;
    padding: 20px 24px 8px;
    text-align: center;
  }
}

.homepage-seo-h1 {
  max-width: 980px;
  margin: 0 auto;
  font-size: 32px;
  font-weight: 700;
  line-height: 1.45;
  letter-spacing: -0.02em;
  color: #013b2d;
}

* {
  color: #344054;
}
</style>
